












































import { Component, Vue } from "vue-property-decorator";
import VesselFiles from "@/components/VesselFiles.vue";
import PdfViewer from "@/components/PdfViewer.vue";
import featureNotAvailable from "@/components/FeatureNotAvailable.vue";
import store from "@/store";
import { getModule } from "vuex-module-decorators";
import VesselsModule from "@/store/clients/Vessels.module";
import vesselFilesClient from "@/Scripts/clients/vessel-files-client";

const Vessels = getModule(VesselsModule, store);

@Component({
  components: {
    VesselFiles,
    PdfViewer,
    featureNotAvailable,
  },
})
export default class VesselFilesView extends Vue {
  vessel = Vessels.currentVessel;
  pdfSrc: any = "";
  downloadUrlId = 0;
  pdfTitle = "Vessel document";

  get featureEnabled(): boolean {
    if (!this.vessel) return false;
    return this.vessel.features.some(feature => feature.name === "Documents");
  }

  get vesselId(): number {
    return parseInt(this.$route.params.vesselId);
  }

  get vesselName(): string {
    return this.vessel?.name || "Vessel";
  }

  handleViewPdf(pdf: any): void {
    this.updatePdf(pdf);
  }

  handleDownloadFile(file: any): void {
    vesselFilesClient.download(file.id);
  }

  handleClosePdf(): void {
    this.pdfSrc = "";
    this.pdfTitle = "Vessel document";
    this.downloadUrlId = 0;
  }

  updatePdf(pdf: any): void {
    vesselFilesClient.getFileUrl(pdf.id).then(data => {
      this.pdfSrc = data;
      this.downloadUrlId = pdf.id;
      this.pdfTitle = pdf.fileName ? pdf.fileName.split("/").pop() : "Vessel document";
    });
  }
}
